import { axiosInstance } from "../client";
import {
  EvaluationGroup,
  EvaluationGroupDetail,
} from "@rumble-it/common-lib/types/models/EvaluationGroup.interface";

export const fetchEvaluationGroups = async (): Promise<EvaluationGroup[]> =>
  axiosInstance
    .get(`/admin/evaluation-groups`)
    .then((response) => response.data);

export const fetchEvaluationGroupById = async (
  id: string,
): Promise<EvaluationGroupDetail> =>
  axiosInstance
    .get(`/admin/evaluation-groups/${id}`)
    .then((response) => response.data);
